import axios from 'axios';
import { B2C_ADDRESSES_PATH, OG_UPDATE_ADDRESS_PROD_URL, OG_UPDATE_ADDRESS_QA_URL, } from '../../constants/links';
import { apiB2C } from '../axios-client';
import { isProd } from '../../utils/environments';
import { getOrderGrooveAddressPayload } from '../../utils/order-groove';
var postOrderGrooveAddressRequest = function (address) {
    return axios.post(isProd() ? OG_UPDATE_ADDRESS_PROD_URL : OG_UPDATE_ADDRESS_QA_URL, getOrderGrooveAddressPayload(address), { headers: { 'Content-Type': 'text/plain;charset=UTF-8' } });
};
var updateOrderGrooveAddress = function (addresses) {
    var _a, _b;
    var newDefaultAddress = (_b = (_a = addresses === null || addresses === void 0 ? void 0 : addresses.addresses) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b.find(function (address) { return address.isDefault; });
    if (newDefaultAddress === null || newDefaultAddress === void 0 ? void 0 : newDefaultAddress.isDefault) {
        postOrderGrooveAddressRequest(newDefaultAddress);
    }
};
export var b2cAddressesApi = {
    getDefaultAddress: function () {
        return apiB2C.get(B2C_ADDRESSES_PATH, {
            params: {
                pageSize: 0,
                pageNumber: 0,
            },
        });
    },
    addNewAddress: function (address) {
        return apiB2C
            .post(B2C_ADDRESSES_PATH, {
            addresses: {
                address: [address],
            },
        })
            .then(function (response) {
            updateOrderGrooveAddress(response.data);
            return response;
        });
    },
    deleteAddress: function (_a) {
        var addrIdentifier = _a.addrIdentifier, lastModifiedDate = _a.lastModifiedDate;
        return apiB2C.delete("".concat(B2C_ADDRESSES_PATH, "/").concat(addrIdentifier), {
            params: {
                lastModifiedDate: lastModifiedDate,
            },
        });
    },
    editAddress: function () {
        var addresses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            addresses[_i] = arguments[_i];
        }
        return apiB2C
            .put(B2C_ADDRESSES_PATH, {
            addresses: {
                address: addresses,
            },
        })
            .then(function (response) {
            updateOrderGrooveAddress(response.data);
            return response;
        });
    },
    getAllAddressess: function () {
        return apiB2C.get(B2C_ADDRESSES_PATH, {
            params: {
                pageSize: 0,
                pageNumber: 0,
            },
        });
    },
};
